import { AnalyticsEvent, AnalyticsManager } from '@oy/analytics';

const trackClickChangeLang = (lang: string) => {
  AnalyticsManager.instance().track(AnalyticsEvent.click_change_language, {
    language: lang,
    current_url: window.location.pathname,
  });
};

// REGISTER PAGE
export const useAuthTrack = () => {
  const trackHitRegisterPage = () => {
    AnalyticsManager.instance().track(AnalyticsEvent.hit_register_page);
  };

  // LOGIN PAGE
  const trackLogin = () =>
    AnalyticsManager.instance().track(AnalyticsEvent.hit_login_page);

  const trackClickSignUp = () =>
    AnalyticsManager.instance().track(AnalyticsEvent.click_sign_up, {
      from: 'primary_access',
    });

  const trackClickLogout = () =>
    AnalyticsManager.instance().track(AnalyticsEvent.click_logout, {
      from: 'pop_up',
    });

  return {
    trackClickChangeLang,
    trackClickLogout,
    trackClickSignUp,
    trackHitRegisterPage,
    trackLogin,
  };
};
